import { Form } from "devextreme-react";
import {
  AsyncRule,
  EmptyItem,
  Label,
  RequiredRule,
  SimpleItem,
} from "devextreme-react/form";
import SiteDropDownBox from "./SiteDropDownBox";
import { useDispatch } from "react-redux";
import {
  updateComment,
  updateINSPCT_MANAGER_NAME,
  updateSiteNo,
} from "./Redux/clinicalSite";
import { useEffect, useState } from "react";
import axios from "axios";
import DataSource from "devextreme/data/data_source";
import styled from "styled-components";

const ClinicalSiteFormWrapper = styled.div`
  .dx-field-item-required-mark {
    color: red;
  }
  .dx-datebox-calendar .dx-dropdowneditor-icon::before {
    content: "\f026";
  }
`;

export default function ClinicalSiteForm(props) {
  const { clinicalSite, siteDropDownBoxRef, formClinicalSiteRef, contrNo } =
    props;

  const dispatch = useDispatch();

  const [INSPCT_MANAGER_NAMEDataSource, setINSPCT_MANAGER_NAMEDataSource] =
    useState(null);

  useEffect(async () => {
    // if (clinicalSite.LAB_SEQ) {
    if (clinicalSite.ykiho) {
      const result = await axios.get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/info/clinicalSiteInfo/inv/${clinicalSite.ykiho}`
      );

      setINSPCT_MANAGER_NAMEDataSource(
        new DataSource({
          store: {
            data: result.data,
            type: "array",
            key: "INSPCT_MANAGER_NAME",
          },
        })
      );
    }
    // }, [clinicalSite.LAB_SEQ]);
  }, [clinicalSite.ykiho]);

  const onSiteNoValueChanged = (e) => {
    dispatch(
      updateSiteNo({
        siteNo: e.value,
      })
    );
  };

  const onINSPCT_MANAGER_NAMEValueChanged = (e) => {
    dispatch(
      updateINSPCT_MANAGER_NAME({
        INSPCT_MANAGER_NAME: e.value,
      })
    );
  };

  const onCommentValueChanged = (e) => {
    dispatch(
      updateComment({
        comment: e.value,
      })
    );
  };

  const onINSPCT_MANAGER_NAMECustomItemCreating = (args) => {
    if (!args.text) {
      args.customItem = null;

      return;
    }

    const newItem = {
      INSPCT_MANAGER_NAME: args.text,
    };

    args.customItem = INSPCT_MANAGER_NAMEDataSource.store()
      .insert(newItem)
      .then(() => INSPCT_MANAGER_NAMEDataSource.load())
      .then(() => newItem)
      .catch((error) => {
        throw error;
      });
  };

  const validateSiteNoCallback = async ({ value }) => {
    // console.debug("[validateSiteNoCallback]");

    if (contrNo) {
      if (clinicalSite.action == "insert") {
        const result = await axios.get(
          `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/info/clinicalSiteInfo/chkSiteNo/${contrNo}/${value}`
        );

        return new Promise((resolve) => {
          setTimeout(() => {
            resolve(result.data.count == 0);
          }, 1000);
        });
      } else {
        return true;
      }
    }
  };

  return (
    <ClinicalSiteFormWrapper>
      <Form
        id="form-clinicalSite"
        ref={formClinicalSiteRef}
        colCount={4}
        labelMode="outside"
        labelLocation="top"
        showColonAfterLabel={true}
        style={{
          padding: "16px",
        }}
        validationGroup="clinicalSiteData"
      >
        <SimpleItem
          dataField={"siteNo"}
          // editorType={"dxNumberBox"}
          editorType={"dxTextBox"}
          editorOptions={{
            value: clinicalSite.siteNo,
            // inputAttr: {
            //   style: "text-align : right",
            // },
            showClearButton: true,
            readOnly: clinicalSite.action == "insert" ? false : true,
            onValueChanged: onSiteNoValueChanged,
          }}
        >
          <Label text={"Site No."} />
          <RequiredRule message={"Site No. is required."} />
          <AsyncRule
            message={"Site No. already exists."}
            validationCallback={validateSiteNoCallback}
          />
        </SimpleItem>
        <SimpleItem dataField={"LAB_NAME"} colSpan={2}>
          <Label text={"Site Name"} />
          <SiteDropDownBox
            clinicalSite={clinicalSite}
            siteDropDownBoxRef={siteDropDownBoxRef}
          />
          <RequiredRule message={"Site name is required."} />
        </SimpleItem>
        <SimpleItem
          dataField={"SIDO"}
          editorType={"dxTextBox"}
          editorOptions={{
            value: clinicalSite.SIDO,
            readOnly: true,
          }}
        >
          <Label text={"Location"} />
        </SimpleItem>

        <SimpleItem
          dataField={"INSPCT_MANAGER_NAME"}
          editorType={"dxSelectBox"}
          editorOptions={{
            dataSource: INSPCT_MANAGER_NAMEDataSource,
            value: clinicalSite.INSPCT_MANAGER_NAME,
            displayExpr: "INSPCT_MANAGER_NAME",
            valueExpr: "INSPCT_MANAGER_NAME",
            showClearButton: true,
            acceptCustomValue: true,
            onValueChanged: onINSPCT_MANAGER_NAMEValueChanged,
            onCustomItemCreating: onINSPCT_MANAGER_NAMECustomItemCreating,
          }}
        >
          <Label text={"PI Name"} />
          <RequiredRule message={"PI name is required."} />
        </SimpleItem>
        <SimpleItem
          dataField={"comment"}
          editorType={"dxTextBox"}
          editorOptions={{
            value: clinicalSite.comment,
            showClearButton: true,
            onValueChanged: onCommentValueChanged,
          }}
          colSpan={3}
        >
          <Label text={"Comment"} />
        </SimpleItem>
      </Form>
    </ClinicalSiteFormWrapper>
  );
}
